import axios from 'axios';
import authHeader from './auth-header';

const API_URL = process.env.VUE_APP_BACKEND_URL + '/api/cart';

class CartService {
    get(id) {
        return axios.get(API_URL + '/' + id, { headers: authHeader() });
    }

    store(data) {
        return axios.post(API_URL, data, { headers: authHeader() });
    }

    update(id, data) {
        return axios.post(API_URL + '/' + id + '?_method=PUT', data, { headers: { ...authHeader(), 'Content-Type': 'multipart/form-data' } });
    }

    destroy(id) {
        return axios.delete(API_URL + '/' + id, { headers: authHeader() });
    }

    getByUserId(user_id) {
        let url = process.env.VUE_APP_BACKEND_URL + '/api/getByUserId/cart';
        return axios.get(url + '/' + user_id, { headers: authHeader() });
    }

    getByCartIds(data) {
        let url = process.env.VUE_APP_BACKEND_URL + '/api/getByCartIds/cart';
        return axios.post(url, data, { headers: authHeader() });
    }

    getNotificationCountByUserId(user_id) {
        let url = process.env.VUE_APP_BACKEND_URL + '/api/getNotificationCountByUserId/cart';
        return axios.get(url + '/' + user_id, { headers: authHeader() });
    }

    restoreByCartIds(data) {
        let url = process.env.VUE_APP_BACKEND_URL + '/api/restoreByCartIds/cart';
        return axios.post(url, data, { headers: authHeader() });
    }
}

export default new CartService();
